// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__1rKdI","active":"NavigationItem_active__2z_p4"};